  import React from "react";
  import "./about-main.css";

  const AboutMain = () => {
    return (
      <section className="about-main">
        {/* Background Blob */}
        <div className="background-blob"></div>
        
        {/* Floating Shapes */}
        <div className="floating-shape shape1"></div>
        <div className="floating-shape shape2"></div>
        <div className="floating-shape shape3"></div>

        <div className="about-content">
          {/* Text Section */}
          <div className="text-block">
            <h1>
              Empowering Your <span>Financial Future</span>
            </h1>
            <p>
             Marathon Finlease Private Limited is committed to delivering innovative and dependable financial solutions tailored to your needs. With trust, transparency, and expertise at the heart of everything we do, we strive to make your financial journey seamless, secure, and empowering — helping you achieve your goals with confidence.
            </p>

            {/* Stats Cards */}
            <div className="stats-cards">
              <div className="card">
                <h2>1000+</h2>
                <p>Happy Clients</p>
              </div>
              <div className="card">
                <h2>24/7</h2>
                <p>Support</p>
              </div>
              <div className="card">
                <h2>99%</h2>
                <p>Customer Satisfaction</p>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="image-block">
            <img
              src="https://picsum.photos/500/400"
              alt="Finance Illustration"
            />
            {/* Callout Bubble */}
            <div className="callout-bubble">
              Trusted by <strong>1000+ Businesses</strong>
            </div>
          </div>
        </div>
      </section>
    );
  };

  export default AboutMain;
